import React from 'react'
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { SiGmail } from 'react-icons/si';
import { contactImg } from "../../assets/index";
import Title from '../layouts/Title';

const Contact = () => {
  return (
    <section
      id="contact"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
    <div className="flex justify-center items-center text-center">
      <Title title="CONTACT" des="Contact Me" />
    </div>
    <div className="flex justify-center">
    <div className="w-full lgl:w-[60%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 flex justify-center items-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">Tamunotonye Briggs</h3>
        <p className="text-lg font-normal text-gray-400">
          Full Stack Developer
        </p>
        <p className="text-base text-gray-400 tracking-wide">
        Hello! I'd love to hear from you. Please feel free to reach out with any questions,
         comments, or opportunities. I'll get back to you as soon as possible. Thank you for getting in touch!
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Phone: <span className="text-lightText">+250 792 957 740</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Email: <span className="text-lightText">trenatto82@gmail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me on</h2>
        <div className="flex gap-4">
        <a href="https://www.linkedin.com/in/tamunotonye-briggs-9193a8203/" target="_blank" rel="noopener noreferrer" className="bannerIcon">
            <FaLinkedinIn />
          </a>
          <a href="https://www.instagram.com/tee_briggz/" target="_blank" rel="noopener noreferrer" className="bannerIcon">
            <FaInstagram />
          </a>
          <a href="mailto:trenatto82@gmail.com" className="bannerIcon">
            <SiGmail />
          </a>
          </div>
      </div>
    </div>
    </div>
    </section>
  );
}

export default Contact